import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import ContentServiceProvider from 'services/content-service/content-service-provider';
import HomeRoomProvider from 'services/homeroom/homeroom-provider';

/**
 * Provides the content based upon the environment.
 *
 * Note that this is sensitive to initialization order. initialize is called in ef.js before others import it
 * This service will not work alone with import because the singleton pattern would be evaluated before the
 * settings service is initialized.
 */
function ContentProvider() {}

ContentProvider.prototype.initialize = function () {
  if (CourseSettingsService.get('progressProvider') === 'content-service') {
    Object.setPrototypeOf(this, ContentServiceProvider);
  } else {
    Object.setPrototypeOf(this, HomeRoomProvider);
  }
  return this;
};

export default new ContentProvider();
